import React, { useState, useEffect } from "react";
import {
  Drawer,
  Typography,
  IconButton,
  Button,
  Checkbox,
} from "@mui/material";
import { Table } from "react-bootstrap";
import { Close as CloseIcon, Visibility as VisibilityIcon } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
// Added by Gauri for Changed NOI section on 07 May 2025
import WorkflowChangeNOI from "./WorkflowChangeNOI";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";

// Commented and Code Added By Madhuri.K on 22-04-2025
const WorkflowConfiguration = ({ data1, data2, data3, initiativesID, onRefresh }) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const accessToken = sessionStorage.getItem("access_token");
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;
  const [currentNOIText, setCurrentNOIText] = useState(null);
  // Added By Madhuri.K on 24-04-2025
  const [currentNOIID, setCurrentNOIID] = useState(null);

  // Commented and Code Added By Madhuri.K on 22-04-2025
  const fetchSaveStageConfiguration = async () => {
    const accessToken = sessionStorage.getItem("access_token");
    const headers = {
      Authorization: `Bearer ${accessToken}`,
    };

    try {
      const response = await AxiosInstance1.get(
        `/api/ManageWorkFlow/GetManageWorkFlowStageConfiguration?IdeaID=${initiativesID}`,
        // { headers }
      );

      const stageList = response.data.data.listStageConfiguration;
      setData(stageList);

      // Add this to select applicable stages on drawer open
      const initiallySelected = stageList
        .filter(item => item.isStageApplicable)
        .map(item => item.initiativeStageID);
      setSelectedItems(initiallySelected);

      console.log("API Response:", stageList);
    } catch (error) {
      console.error("Error fetching stage configuration data:", error);
    }
  };

  useEffect(() => {
    if (data2?.natureofDemand || data2?.natureofDemandID) {
      setCurrentNOIText(data2.natureofDemand);
      setCurrentNOIID(data2?.natureofDemandID);
    }
  }, [data2]);

  useEffect(() => {
    fetchSaveStageConfiguration();
  }, [initiativesID]);
   
  const handleSelectItem = (event, item) => {
    if (event.target.checked) {
      setSelectedItems((prevSelected) => [...prevSelected, item.initiativeStageID]);
    } else {
      setSelectedItems((prevSelected) =>
        prevSelected.filter((id) => id !== item.initiativeStageID)
      );
    }
  };
  
  const handleSaveStageConfiguration = async () => {
    // Get stages that are either selected or disabled (for validation)
    const totalCheckedStages = data.filter(
      (stage) =>
        selectedItems.includes(stage.initiativeStageID) || stage.isDisabled
    );
  
    if (totalCheckedStages.length < 3) {
      toast.error("There should be at least 3 active stages.");
      return;
    }
  
    // Get only selected and NOT disabled stage IDs for the API
    const filteredSelectedIDs = selectedItems.filter((id) => {
      const matchedStage = data.find((stage) => stage.initiativeStageID === id);
      return matchedStage && !matchedStage.isDisabled;
    });
  
    // Key change: If nothing selected, pass "0"
    const selectedStageIDs =
      filteredSelectedIDs.length > 0
        ? [...new Set(filteredSelectedIDs)].join(",")
        : "0";
  
    console.log("selectedStageIDs", selectedStageIDs);
  
    const apiUrl = `/api/ManageWorkFlow/PostStageConfiguration?IdeaID=${initiativesID}&UserID=${employeeId}&SelectedStageIDs=${selectedStageIDs}`;
  
    try {
    const response = await AxiosInstance1.post(apiUrl, null, {
      headers: {
        // Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    const result = response?.data?.data?.[0]?.result;
    console.log("API Response:", response.data);

    if (result === "Success") {
      toast.success("Stage Configuration saved successfully");
      if (onRefresh) {
        onRefresh();
      }
      setOpen(false);
    } else {
      toast.error("Failed to save Stage Configuration.");
    }
  } catch (error) {
    console.error("Error saving data:", error);
    toast.error("An error occurred while saving.");
  }

    // fetch(apiUrl, {
    //   method: "POST",
    //   headers: {
    //     Authorization: `Bearer ${accessToken}`,
    //     "Content-Type": "application/json",
    //   },
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log("API Response:", data);
  
    //     if (data?.data?.[0]?.result === "Success") {
    //       toast.success("Stage Configuration saved successfully");
    //       if (onRefresh) {
    //         onRefresh();
    //       }
    //       setOpen(false);
    //     } else {
    //       toast.error("Failed to save Stage Configuration.");
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error saving data:", error);
    //     toast.error("An error occurred while saving.");
    //   });
  };

  const handleStageConfDrawerOpen = () => {
    setOpen(true);
    // setSelectedItems([]); // Reset selected items when opening the drawer
    fetchSaveStageConfiguration(); // Fetch data when opening the drawer
  }

  return (
    <div style={{ padding: "20px", backgroundColor: "#f9f9f9" }}>
      <Typography
        variant="subtitle1"
        style={{ marginBottom: "20px", fontWeight: "bold" }}
      >
        1. Stage Configuration
      </Typography>
      <div>
        <Typography variant="body1" style={{ marginBottom: "20px" }}>
          {/* Commented and passed data2 values to this component by Gauri on 05 Feb 2025 */}
          {/* You are using 'Budget' Nature Of initiative for '{initiativesID}' Initiative for approval. */}
          You are using <strong>'{currentNOIText}'</strong> Nature of
          initiative for <strong>'{data2?.title}'</strong> Initiative for
          approval. Click on&nbsp;
          <a
            href="javascript:;"
            // onClick={() => setOpen(true)}
            onClick={handleStageConfDrawerOpen}
            // Commented and Code Added By Madhuri.K on 23-04-2025
            // style={{ textDecoration: "underline", cursor: "pointer" }}
            style={{
              textDecoration: "underline",
              cursor: "pointer",
              fontWeight: "bold",
              color: "blue",
            }}
          >
            Stage Configuration
          </a>
          &nbsp;to skip a few stages from the approval cycle.
        </Typography>
      </div>
      {/* Drawer for Stage Configuration */}
      <Drawer
        anchor="right"
        open={open}
        onClose={() => {
          setOpen(false);
          setSelectedItems([]);
        }}
        PaperProps={{
          sx: { width: "60vw" },
        }}
      >
        <div style={{ padding: "20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
              backgroundColor: "#f0f0f0", // Light grey background color
              padding: "10px", // Optional: add padding to ensure content doesn't touch the edges
              borderRadius: "4px", // Optional: add rounded corners for a smoother look
            }}
          >
            <Typography variant="h6">Stage Configuration</Typography>
            <IconButton onClick={() => setOpen(false)}>
              <Tooltip title="Close">
                <CloseIcon />
              </Tooltip>
            </IconButton>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
            <Button variant="contained" color="primary" onClick={handleSaveStageConfiguration}>
              Save
            </Button>
          </div>

          {/* Table Mofified by Madhuri.K on 23-04-2025 */}
          <Table className="table table-bordered">
            <thead>
              <tr>
                <th align="center">Nature of Initiative</th>
                <th align="center">Stage</th>
                <th align="center">Applicable</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item) => (
                <tr key={item.initiativeStageID}>
                  <td align="left">{item.noi}</td>
                  <td align="left">{item.requestStage}</td>
                  <td align="center">
                    {/* Commented and Code Added By Madhuri.K on 22-04-2025 */}
                    {/* <Checkbox
                      // commented By Madhuri.K On 22-04-2025
                        // checked={selectedItems.includes(item.stageID)}
                        checked={item.isDisabled || selectedItems.includes(item.stageID)}

                        onChange={(event) =>
                          handleSelectItem(event, item.stageID)
                        }
                        disabled={item.isDisabled} // Disable checkbox if item.isDisabled is true
                      /> */}
                    {/* <Checkbox
                        // checked={
                        //   item.isDisabled || item.isStageApplicable || selectedItems.includes(item.stageID)
                        // }
                        checked={
                          item.isDisabled
                            ? true
                            : selectedItems.includes(item.initiativeStageID)
                        }
                        
                        onChange={(event) =>
                          handleSelectItem(event, item.initiativeStageID)
                        }
                        disabled={item.isDisabled}
                      /> */}
                    <Checkbox
                      checked={
                        item.isDisabled || selectedItems.includes(item.initiativeStageID)
                      }
                      onChange={(event) => handleSelectItem(event, item)}
                      disabled={item.isDisabled}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

        </div>
      </Drawer>
      {/* Hide Change Nature of Initiative in manage workflow by Shivam More on 16 Jul 2025 */}
      {/* <WorkflowChangeNOI 
        data1={data1} 
        data2={data2} 
        data3={data3} 
        initiativesID={initiativesID}
        onRefresh={onRefresh}
      /> */}
    </div>
  );
};

export default WorkflowConfiguration;
